import React from 'react';
// eslint-disable-next-line import/no-unassigned-import
import '../../corecss/homeCore.css';
import pageStyles from '../../index.less';
import Breadcrumbs from '../../components/breadcrumbs/Breadcrumbs';
import SearchSummary from '../../components/searchsummary/SearchSummary';
import Metadata from '../../components/metadata/Metadata';
import { SeoFooterContainer } from '../../components/seofooter/SeoFooterContainer';
import SearchResults from '../../components/searchresults/SearchResults';
import SearchBlock from '../../components/searchBlock/SearchBlock';
import { HeyImmoWidget } from '../../components/heyImmoWidget/HeyImmoWidget';
import RegionSeoContent from '../../components/regionseocontent/RegionSeoContent';
import { useAppDispatch, useAppSelector } from '../../store/store';
import * as actions from '../../thunks/search';
var Search = function Search() {
  var dispatch = useAppDispatch();
  var geoPathUri = useAppSelector(function (state) {
    var _state$gacOverAllInfo;
    return ((_state$gacOverAllInfo = state.gacOverAllInfo.selectedSuggestion) === null || _state$gacOverAllInfo === void 0 ? void 0 : _state$gacOverAllInfo.geoPath.uri) || '';
  });
  var geoPathRealNames = useAppSelector(function (state) {
    var _state$gacOverAllInfo2;
    return ((_state$gacOverAllInfo2 = state.gacOverAllInfo.selectedSuggestion) === null || _state$gacOverAllInfo2 === void 0 ? void 0 : _state$gacOverAllInfo2.geoPath.realNames) || [];
  });
  var neighbourRegions = useAppSelector(function (state) {
    var _state$seoData;
    return (_state$seoData = state.seoData) === null || _state$seoData === void 0 ? void 0 : _state$seoData.neighbourRegions;
  });
  var childrenRegions = useAppSelector(function (state) {
    var _state$seoData2;
    return (_state$seoData2 = state.seoData) === null || _state$seoData2 === void 0 ? void 0 : _state$seoData2.childrenRegions;
  });
  var childrenRegionType = useAppSelector(function (state) {
    var _state$seoData3;
    return (_state$seoData3 = state.seoData) === null || _state$seoData3 === void 0 ? void 0 : _state$seoData3.childrenRegionType;
  });
  var neighbourRegionType = useAppSelector(function (state) {
    var _state$seoData4;
    return (_state$seoData4 = state.seoData) === null || _state$seoData4 === void 0 ? void 0 : _state$seoData4.neighbourRegionType;
  });
  var domain = useAppSelector(function (state) {
    return state.config.DOMAIN;
  });
  React.useEffect(function () {
    window.onpopstate = function () {
      dispatch(actions.onUrlChange());
    };
  }, [dispatch]);
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(pageStyles.mainPageStyle, " padding-none")
  }, /*#__PURE__*/React.createElement(Metadata, null), /*#__PURE__*/React.createElement("div", {
    className: "content-wrapper padding-top lap-padding-horizontal-l palm-padding-horizontal-l"
  }, /*#__PURE__*/React.createElement(Breadcrumbs, {
    geoPathUri: geoPathUri,
    geoPathRealNames: geoPathRealNames
  }), /*#__PURE__*/React.createElement(SearchBlock, null), /*#__PURE__*/React.createElement(SearchSummary, null)), /*#__PURE__*/React.createElement(SearchResults, null), /*#__PURE__*/React.createElement(RegionSeoContent, null), /*#__PURE__*/React.createElement("hr", {
    className: pageStyles.divider
  }), /*#__PURE__*/React.createElement(SeoFooterContainer, {
    neighbourRegions: neighbourRegions,
    childrenRegions: childrenRegions,
    childrenRegionType: childrenRegionType,
    neighbourRegionType: neighbourRegionType,
    domain: domain,
    geoPathUri: geoPathUri
  }), /*#__PURE__*/React.createElement("hr", {
    className: pageStyles.divider
  }), /*#__PURE__*/React.createElement(HeyImmoWidget, null));
};
export default Search;